/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {SelectPageSize} from '../../../../../../components/SelectPageSize/SelectPageSize'
import {StyledCard} from '../../../../../../components/StyledCard'
import * as TableUI from '../../../../../../components/Table/Table'
import {useRowTable} from '../../../../../../hooks/useRowTable'
import {useAppDispatch, useAppSelector} from '../../../../../../redux/hooks'
import {
  filterSelector,
  resetFilterLogSalesOrder,
  setFilterLogSalesOrder,
  setIsFetchData,
} from '../../../../../../redux/slices/filterSlices'
import {fetchLogSalesOrder, headers} from '../../../../../../services/fetcher'
import {objToParams} from '../../../../../../utils/objToParams'
import Pagination from '../../../../component/Pagination'
import {RowFilter} from './RowFilter'
import {RowHead} from './RowHead'
import {StyledButtonGroups} from '../../../../../../components/StyledButtonGroups'
import {RowData} from './RowData'
import { EditModal } from '../components/EditModal'
import { DetailModal } from '../components/DetailModal'
import { getErrorSAPList } from 'src/api/modules/master-data/master_2'
import { addLog, editLog } from 'src/api/modules/log/sales-order'
import { useTranslation } from 'react-i18next'
import swal from 'sweetalert'
import i18next from 'i18next'
import { KTSVG } from 'src/_metronic/helpers'
import { AddModal } from '../components/AddModal'

const MemoizedRowFilter = React.memo(RowFilter)
const MemoizedSelectPageSize = React.memo(SelectPageSize)

type Props = {
  className: string
}

const TableLog: React.FC<Props> = ({className}) => {
  const {filterLogSalesOrder} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const {t} = useTranslation()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 14,
    onReloadTable: () => dispatch(resetFilterLogSalesOrder()),
  })

  const [logs, setLogs] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [isError, setIsError] = useState(false)
  const [log, setLog] = useState<any>()
  const [logErrors, setLogErrors] = useState<any>([])
  const [showModalDetail, setShowModalDetail] = useState<boolean>(false)
  const [showModalAdd, setShowModalAdd] = useState<boolean>(false)
  const [showModalEdit, setShowModalEdit] = useState<boolean>(false)
  const [isEditingLog, setIsEditingLog] = useState<boolean>(false)
  const [isAddingLog, setIsAddingLog] = useState<boolean>(false)

  const [errorTypeSAPList, setErrorTypeSAPList] = useState<any>([])

  const rowNumber = useMemo(() => {
    const per = filterLogSalesOrder?.per_page ?? 5
    return page * per - per
  }, [filterLogSalesOrder, page])

  const onFetchLogAPI = useCallback(() => {
    setLoading(true)
    setIsError(false)

    fetchLogSalesOrder(filterLogSalesOrder)
      .then((res) => {
        setLogs(res.data.data.data)
        setPage(res.data.data.current_page)
        setNumberURL(res.data.data.links)
        console.log(res.data.data.data)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterLogSalesOrder])

  const paginateNumber = async (url: string) => {
    if (!url) return
    try {
      setLoading(true)
      setIsError(false)

      const endpoint = `${url}&${objToParams(filterLogSalesOrder)}`
      const token = localStorage.getItem('token') as string
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setLogs(data.data)
      setPage(data.current_page)
      setNumberURL(data.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  const handleResetTable = () => {
    dispatch(resetFilterLogSalesOrder())
  }

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterLogSalesOrder({... filterLogSalesOrder, per_page: value ?? 5}))
  }

  useEffect(() => {
    const getData = setTimeout(onFetchLogAPI, 1000)
    return () => clearTimeout(getData)
  }, [onFetchLogAPI])

  useEffect(() => {
    setErrorTypeSAP()
  }, [])

  const onEdit = (data: any) => {
    setLog(data)
    setShowModalEdit(true)
  }

  const onDetail = (data: any) => {
    setLogErrors(data?.errors.map((item: any) => {
      return {
        ... item,
        date: data?.execution_date
      }
    }))
    setShowModalDetail(true)
  }

  const setErrorTypeSAP = async () => {
    await getErrorSAPList().then((res: any) => setErrorTypeSAPList(res.data?.data))
  }

  const handleEdit = async (payload: any) => {
    setIsEditingLog(true)
    await editLog(log?.id, {
      ... payload,
      lang: i18next.language
    })
    .then(() => {
      swal({
        title: payload?.send_to_sap ? `${t('Berhasil Edit dan Kirim ulang')}` : `${t('Berhasil Edit')}`,
        icon: 'success',
      }).then(() => {
        setShowModalEdit(false)
        onFetchLogAPI()
      })
    })
    .catch((error) => {
      swal({
        closeOnClickOutside: false,
        title: t(error.response.data.message),
        icon: 'error',
      })
    })
    .finally(() => setIsEditingLog(false))
  }

  const handleAdd = async (payload: any) => {
    setIsAddingLog(true)
    await addLog({
      ... payload,
      lang: i18next.language
    })
    .then(() => {
      swal({
        title: t('data-added-successfully'),
        icon: 'success',
      }).then(() => {
        setShowModalAdd(false)
        onFetchLogAPI()
      })
    })
    .catch((error) => {
      swal({
        closeOnClickOutside: false,
        title: t(error.response.data.message),
        icon: 'error',
      })
    })
    .finally(() => setIsAddingLog(false))
  }

  const hasFilter = () => {
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-log-so-filter') || '')
      console.log(persisted)
      return persisted
    }catch(e){ return null }
  }

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <>
            <MemoizedSelectPageSize
              initialValue={filterLogSalesOrder?.per_page ?? 5}
              onChange={(value: any) => handlePageSizeChange(value?.value)}
            />
            { hasFilter() && 
              <button type="button" onClick={() => handleResetTable()} className="btn btn-outline-danger btn-sm">Clear Filter</button> 
            }
          </>
        }
        rightContent={
          <>
            <button onClick={() => setShowModalAdd(true)} className='btn btn-primary d-flex align-items-center'>
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              <p>{t('order-tambah')}</p>
            </button>
            <button
              className='btn btn-sm btn-primary'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='/hover'
              title={t('reload table')}
              onClick={onFetchLogAPI}
            >
              <i className='fas fa-sync-alt'></i>
            </button>
          </>
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <RowHead />
          </TableUI.THead>
          <TableUI.TBody>
            <MemoizedRowFilter error_type_list={errorTypeSAPList} />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : logs.length === 0 ? (
              <RowEmptyData />
            ) : (
              <RowData 
                items={logs} 
                rowNumber={rowNumber} 
                onEdit={(data) => onEdit(data)}
                onDetail={(data) => onDetail(data)}
              />
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination 
        paginate={paginateNumber} 
        test={numberURL} 
      />

      <AddModal
        options={{
          processing_types: errorTypeSAPList
        }} 
        data={log} 
        showModal={showModalAdd}
        isLoading={isAddingLog} 
        closeModal={() => setShowModalAdd(false)} 
        submit={handleAdd}
      />

      <EditModal 
        options={{
          processing_types: errorTypeSAPList
        }}
        data={log} 
        showModal={showModalEdit}
        isLoading={isEditingLog} 
        closeModal={() => setShowModalEdit(false)} 
        edit={handleEdit}
      />

      <DetailModal 
        data={logErrors} 
        showModal={showModalDetail} 
        closeModal={() => setShowModalDetail(false)} 
      />

    </StyledCard>
  )
}

export {TableLog}
